export const EquipmentCategoryFactory = () => {
    return function EquipmentCategory() {
        this.id = null;
        this.par_id = null;
        this.code = null;
        this.name = null;
        this.isRegulated = null;
    };
};
